// let whiteNav = document.querySelectorAll(".nav-outer")[1];

// let darkNav = document.querySelectorAll(".nav-outer")[0];

// let navHeight = document.querySelector(".nav").offsetHeight;

// const navCheck = () => {
//   let protectedSectionTop = document.querySelector(".protected-section").getBoundingClientRect().y;

//   whiteNav.style.clipPath = `inset(0px 0px ${navHeight - Math.max(0, Math.min(navHeight, protectedSectionTop))}px 0px)`;

//   darkNav.style.clipPath = `inset(${Math.max(0, Math.min(navHeight, protectedSectionTop))}px 0px 0px 0px)`;
// };

// navCheck();

// window.addEventListener("scroll", navCheck);

// mobile nav

const navBurgers = document.querySelectorAll(".nav__burger-menu");

const mobileMenu = document.querySelector(".mobile-menu");

const nav = document.querySelector(".nav");

const toggleNav = (open) => {
  // console.log("toggle nav. open? ", open);
};

navBurgers.forEach((burger) => {
  burger.addEventListener("click", () => {
    navBurgers.forEach((burger) => {
      burger.classList.toggle("active");
    });

    mobileMenu.classList.toggle("mobile-menu--open", burger.classList.contains("active"));
    nav.classList.toggle("nav--open", burger.classList.contains("active"));
  });
});
